import { useGetPublicProfileCreatedRoomsQuery } from 'src/features/public-profile/components/created-rooms-tab/created-rooms.slice';

import { UseGetRoomsResponse } from '../public-profile.types';

export const useGetCreatedRooms = (userId: string, page: number, limit = 16): UseGetRoomsResponse => {
  const { data, isLoading, refetch } = useGetPublicProfileCreatedRoomsQuery(
    { user: userId, limit, page },
    { skip: !userId },
  );

  return {
    rooms: data?.data?.docs,
    isLoading,
    refetch,
    totalRooms: data?.data?.totalDocs,
    totalPages: data?.data?.totalPages,
  };
};
